import { Box, Text } from '@chakra-ui/react'

// Says that a context could not be read.
//
// Without it a failure is indistinguishable from an empty organization: the
// widgets fall back to "—" and an empty calendar, which is exactly what a real
// organization with nothing scheduled looks like. A coach would read a 403 as
// "this team has no data" and go looking for the wrong problem.

interface IScopeErrorNoticeProps {
  message: string
}

const ScopeErrorNotice = ({ message }: IScopeErrorNoticeProps) => (
  <Box
    role="alert"
    bg="rgba(229,62,62,0.12)"
    border="1px solid"
    borderColor="rgba(229,62,62,0.35)"
    borderRadius="10px"
    px="14px"
    py="10px"
  >
    <Text color="#FEB2B2" fontSize="13px" fontWeight={500} m={0}>
      {message}
    </Text>
  </Box>
)

export default ScopeErrorNotice
